
import { defineComponent } from 'vue'
import IpTrackerInput from './IpTrackerInput.vue'

export default defineComponent({
  name: 'IpTracker',

  components: { IpTrackerInput }
})
